import type { IconData } from '@stacksjs/iconify-core'

export const taillessLineArrowRightCircleRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M43.5 24c0-10.77-8.73-19.5-19.5-19.5S4.5 13.23 4.5 24S13.23 43.5 24 43.5S43.5 34.77 43.5 24M24 .5C36.979.5 47.5 11.021 47.5 24S36.98 47.5 24 47.5S.5 36.98.5 24S11.02.5 24 .5m-4.681 10.22c1.401-.985 3.088-.452 4.15.503c3.288 2.954 7.657 7.378 9.876 10.317c1.122 1.485 1.122 3.433 0 4.919c-2.218 2.939-6.588 7.362-9.875 10.317c-1.063.955-2.75 1.488-4.151.502c-.927-.651-1.81-1.538-2.536-2.407c-1.172-1.402-.859-3.357.335-4.55L23.439 24l-6.321-6.321c-1.193-1.193-1.507-3.148-.335-4.55c.727-.87 1.61-1.756 2.536-2.408\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default taillessLineArrowRightCircleRemix
